import { createFileRoute } from '@tanstack/react-router';
import { EntityCardPage } from '../features/entities/EntityCardPage';
import { validateCardSearch } from '../lib/cardSearch';

export const Route = createFileRoute('/entities/$id')({
  validateSearch: validateCardSearch,
  component: function CardRoute() {
    const { id } = Route.useParams();
    return <EntityCardPage id={id} />;
  },
});
